import useSession from './useSession'

// Purpose of this hook is simply to consolidate the logic of storing and retrieving a
// post logout uri in a given session storage value so that it can be called from
// different places without the callers having to know how it's working
export default function useLogout() {
    const [postLogoutUri, setPostLogoutUri] = useSession(null, "practicemd_post_logout_uri")
    return [postLogoutUri, setPostLogoutUri]
}
